import * as React from 'react';
import {
  Box, createStyles, Grid, makeStyles, Typography,
} from '@material-ui/core';
import { grey } from '@material-ui/core/colors';
import type ILabelEnumPair from '../../global/GlobalInterfaces';
import { colors } from '../../../theme';

const useStyles = makeStyles(() => createStyles({
  setName: {
    textAlign: 'center',
    fontWeight: 400,
    fontSize: '10px',
    lineHeight: '11.72px',
    paddingBottom: '3px',
  },
  setCount: {
    textAlign: 'center',
    fontWeight: 600,
    fontSize: '16px',
    lineHeight: '18.75px',
  },
  squond: {
    borderRadius: '5px',
    padding: '8px !important',
    width: '72px',
  },
  nonSquond: {
    padding: '8px !important',
    width: '72px',
  },
}));

interface IWorkViewSetProp {
  setName: string;
  displayStyle: ILabelEnumPair;
  isColored: boolean;
  color: string;
  setData: number;
}

const WorkViewSet: React.FC<IWorkViewSetProp> = ({
  setName,
  displayStyle,
  isColored,
  color,
  setData,
}) => {
  // Initial imports
  const usesColor = isColored;
  const classes = useStyles();

  const colorClass = () => {
    if (color === 'blue') {
      return colors?.blue;
    }
    if (color === 'orange') {
      return colors.orange;
    }
    if (color === 'yellow') {
      return colors.yellow;
    }
    if (color === 'maroon') {
      return colors.maroon;
    }
    if (color === 'red') {
      return colors.red;
    }
    return colors.blue;
  };

  // Render
  return (
    <>
      {usesColor ? (
        <Grid item style={{ padding: '4px 0' }}>
          {displayStyle.label === 'Squond' ? (
            <Box px={2} py={2} sx={{ bgcolor: colorClass() }} className={classes.squond}>
              <Typography className={classes.setName} style={{ color: 'white' }}>
                {setName}
              </Typography>
              <Typography className={classes.setCount} style={{ color: 'white' }}>
                {setData}
              </Typography>
            </Box>
          ) : (
            <Box px={2} py={2} sx={{ bgcolor: colorClass() }} className={classes.nonSquond}>
              <Typography className={classes.setName} style={{ color: 'white' }}>
                {setName}
              </Typography>
              <Typography className={classes.setCount} style={{ color: 'white' }}>
                {setData}
              </Typography>
            </Box>
          )}
        </Grid>
      ) : (
        <Grid item style={{ padding: '4px 0' }}>
          {displayStyle.label === 'Squond' ? (
            <Box px={2} py={2} sx={{ bgcolor: grey[100] }} className={classes.squond}>
              <Typography className={classes.setName}>
                {setName}
              </Typography>
              <Typography className={classes.setCount}>
                {setData}
              </Typography>
            </Box>
          ) : (
            <Box px={2} py={2} sx={{ bgcolor: grey[100] }} className={classes.nonSquond}>
              <Typography className={classes.setName}>
                {setName}
              </Typography>
              <Typography className={classes.setCount}>
                {setData}
              </Typography>
            </Box>
          )}
        </Grid>
      )}
    </>
  );
};

export default WorkViewSet;
